import { Select } from 'antd';
import { getLeadsFilter, setLeadsFilter } from 'store/leads';
import { Sorting } from 'types/common';
import { LeadsFilter, LeadsOrderBy } from 'types/leads';
import { useAppDispatch, useAppSelector } from 'utils/hooks';
import { arrowDownPurple } from 'assets/images';
import './LeadsStatusSorting.scss';

enum LeadsSorting {
	ALPHABET_ASC = 'A-Z',
	ALPHABET_DESC = 'Z-A',
	CREATED_ASC = '1-31',
	CREATED_DESC = '31-1',
}

const { ALPHABET_ASC, ALPHABET_DESC, CREATED_ASC, CREATED_DESC } = LeadsSorting;

const LeadsStatusSorting = (): JSX.Element => {
	const dispatch = useAppDispatch();

	const filter: LeadsFilter = useAppSelector(getLeadsFilter);

	const handleSelect = (value: LeadsSorting): void => {
		switch (value) {
			case ALPHABET_ASC: {
				dispatch(setLeadsFilter({ ...filter, orderBy: LeadsOrderBy.ALPHABET, sorting: Sorting.ASC }));
				break;
			}
			case ALPHABET_DESC: {
				dispatch(setLeadsFilter({ ...filter, orderBy: LeadsOrderBy.ALPHABET, sorting: Sorting.DESC }));
				break;
			}
			case CREATED_ASC: {
				dispatch(setLeadsFilter({ ...filter, orderBy: LeadsOrderBy.CREATED, sorting: Sorting.ASC }));
				break;
			}
			case CREATED_DESC: {
				dispatch(setLeadsFilter({ ...filter, orderBy: LeadsOrderBy.CREATED, sorting: Sorting.DESC }));
				break;
			}
		}
	};

	return (
		<Select
			defaultValue={CREATED_DESC}
			dropdownClassName="lead-status-sorting__dropdown"
			onSelect={handleSelect}
			placeholder="Sort"
			suffixIcon={<img alt="" src={arrowDownPurple} />}
		>
			{Object.values(LeadsSorting).map(value => (
				<Select.Option key={value} value={value}>
					{value}
				</Select.Option>
			))}
		</Select>
	);
};

export default LeadsStatusSorting;
